// extracted by mini-css-extract-plugin
module.exports = {"info_box":"info_box-30wn8YAI clearfix","comment":"comment-3NgFAdYC","pic":"pic-chLotz5C","v_logo":"v_logo-2n3Bmw78","text":"text-3gJi6os5","time":"time-lpdmslUz"};